import { DateTime } from "luxon";
import { Link, useSearchParams } from "react-router-dom";
import defaultIcon from "../../assets/default-icon.png";
import { useFeedSearch } from "../api/feed-search";

export default function Search() {
    const [searchParams, setSearchParams] = useSearchParams();
    const query = searchParams.get("q");

    const q = useFeedSearch(query),
        { isSuccess, isFetching, data: { found = [], errorMessage } = {} } = q;

    const onSubmit = event => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const q = formData.get("q");
        if (!q) return;
        setSearchParams({ q: q.trim() });
    };

    const showLink = (q, url) => ({
        pathname: "/register/host",
        search: new URLSearchParams({
            q: q.trim(),
            url
        }).toString()
    });

    return (
        <>
            <h1>Get Started Measuring Your Podcast Traffic and Demographics with Podtrac</h1>
            <h2>Find Your Show</h2>
            <p>
                Enter your <b>show name</b> or <b>RSS feed URL</b> below. We’ll search for your show
                and let you know which Podtrac services are supported by your podcast host.
            </p>
            <form onSubmit={onSubmit} style={{ marginBottom: "2rem" }}>
                <input
                    name="q"
                    placeholder="show name or RSS feed URL"
                    style={{ width: "30ch", fontSize: "1.25rem", padding: "0.5rem" }}
                    defaultValue={query ?? undefined}
                />{" "}
                <button
                    disabled={isFetching}
                    className="button"
                    style={{ fontSize: "1.25rem", padding: "0.5rem" }}
                >
                    Search{isFetching ? "..." : ""}
                </button>
            </form>
            <div style={{ marginTop: "1rem" }}>
                {errorMessage ? (
                    <>
                        <h2>Error</h2>
                        <p>{errorMessage}</p>
                    </>
                ) : isFetching ? (
                    <h2>Searching...</h2>
                ) : isSuccess ? (
                    found.length ? (
                        <>
                            <h2>Select Your Show</h2>
                            {found.map((f, i) => (
                                <div
                                    key={i}
                                    style={{
                                        display: "flex",
                                        margin: "1rem 0 2rem"
                                    }}
                                >
                                    <Link
                                        to={showLink(query, f.url)}
                                        style={{
                                            width: "4.5rem",
                                            marginRight: "0.75rem",
                                            flexShrink: 0
                                        }}
                                    >
                                        <ResultImage feed={f} />
                                    </Link>
                                    <div>
                                        <div
                                            style={{
                                                marginBottom: "0.25rem",
                                                fontWeight: "bold",
                                                fontSize: "1.25em"
                                            }}
                                        >
                                            <Link to={showLink(query, f.url)}>{f.title}</Link>
                                        </div>
                                        <div
                                            style={{
                                                marginBottom: "0.25rem",
                                                maxWidth: "60ch",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis"
                                            }}
                                            title={f.url}
                                        >
                                            {f.url}
                                        </div>
                                        <div style={{ fontSize: "0.8em", color: "#666" }}>
                                            Latest episode:{" "}
                                            {f.lastEpisode &&
                                                DateTime.fromISO(f.lastEpisode, {
                                                    zone: "utc"
                                                }).toLocaleString(DateTime.DATE_FULL)}{" "}
                                            {/*<span style={{ color: "#999" }}>({f.source})</span>*/}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <>
                            <h2>No results found.</h2>
                            <p>
                                We use Apple’s podcast database to identify shows. If your podcast
                                is not available on Apple Podcasts it won’t appear in our results
                                but may still be measurable by Podtrac. Try entering the RSS URL
                                instead of the show name or searching again with variations on the
                                show name. If you still don’t get results contact{" "}
                                <a href="mailto:support@podtrac.com">support@podtrac.com</a> with
                                the RSS URL and show name.
                            </p>
                        </>
                    )
                ) : null}
            </div>
            {/*<pre
                style={{ marginTop: "100vh", background: "#eee", padding: "1em", overflow: "auto" }}
            >
                {JSON.stringify(q, null, 2)}
            </pre>*/}
        </>
    );
}

// cache erroring images so we don't keep reloading them
const badImages = {};
export function ResultImage({ feed, size = "4.5rem", marginRight }) {
    return (
        <img
            onError={event => {
                badImages[feed.imageUrl] = true;
                event.target.src = defaultIcon;
            }}
            style={{
                border: "1px solid #eee",
                width: size,
                height: size,
                marginRight,
                flexShrink: 0
            }}
            src={feed.imageUrl && !badImages[feed.imageUrl] ? feed.imageUrl : defaultIcon}
        />
    );
}
